"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentSchema = exports.ShippingAddressSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.ShippingAddressSchema = __1.AddressSchema.extend({
    name: __1.ShortStringSchema.optional(),
    receiverName: __1.ShortStringSchema.optional(),
    receiverPhone: __1.PhoneSchema.optional(),
    reference: __1.ShortStringSchema.optional(),
});
exports.ShipmentSchema = __1.BaseSchema.extend({
    canceledAt: zod_1.z.coerce.date().optional(),
    channelMode: __1.ShortStringSchema.optional(),
    channelShipmentId: __1.ShortStringSchema.optional(),
    channelStatus: __1.ShortStringSchema.optional(),
    deliveredAt: zod_1.z.coerce.date().optional(),
    handlingStartedAt: zod_1.z.coerce.date().optional(),
    labelUrl: __1.LongStringSchema.url().optional(),
    readyToShipAt: zod_1.z.coerce.date().optional(),
    receiverAddress: exports.ShippingAddressSchema,
    returnedAt: zod_1.z.coerce.date().optional(),
    senderAddress: exports.ShippingAddressSchema.optional(),
    shippedAt: zod_1.z.coerce.date().optional(),
    status: __1.ShortStringSchema.optional(),
    trackingCode: __1.ShortStringSchema.optional(),
    trackingMethod: __1.ShortStringSchema.optional(),
    trackingUrl: __1.LongStringSchema.url().optional(),
    shippingMethod: zod_1.z.nativeEnum(__1.ShippingMethod).optional(),
});
//# sourceMappingURL=shipment.js.map